  document.addEventListener("DOMContentLoaded", () => {
  const hidePlan = () => {
    const widget = document.querySelector('recharge-subscription-widget');
    const plans = widget?.shadowRoot?.querySelector('rc-selling-plans');
    
    if (plans?.shadowRoot) {
      const labels = plans.shadowRoot.querySelectorAll('[part~="rc-plans-radio-button"]');
      if (labels[3]) {
        labels[3].style.display = 'none';
      }
      if (labels[4]) {
        labels[4].style.display = 'none';
      }
      if (labels[5]) {
        labels[5].style.display = 'none';
      }
    }
    return false;
  };

  // 1. Try immediately
  if (!hidePlan()) {
    // 2. If it wasn't ready, watch the DOM for the widget to load
    const observer = new MutationObserver((mutations, obs) => {
      if (hidePlan()) {
        obs.disconnect(); // Stop watching once we've hidden it
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
});
